export const TOAST_TIMEOUT = 5000